import React, { useMemo, useRef } from 'react';
import CommonGrid from '../../../../../common/GridWithHeader/CommonGrid';
import GridConfig from './GridConfig';

const UsageDetails = ({ data, selectedTerminal, userData }) => {
  const gridConfig = useRef(new GridConfig({ userConfig: userData.userProfile?.columnPref }));
  const filteredData = useMemo(() => {
    return selectedTerminal ? data.filter((item) => item.terminalCode === selectedTerminal) : data;
  }, [data, selectedTerminal]);

  return (
    <CommonGrid
      title="Details By Date"
      data={filteredData}
      exportFileName="usage_of_dynamic_routing_details_by_date"
      config={gridConfig.current.config}
      gridHeaderConfig={{
        showFullscreen: false
      }}
    />
  );
};

export default UsageDetails;
